module.exports = __webpack_public_path__ + "img/dashboards-icon-10.f6a9bc69.jpg";